import src from "IMAGE";
export default { src, width: 1840, height: 427, blurWidth: 0, blurHeight: 0};
